// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  position: absolute !important;

  width: 1px !important;
  height: 1px !important;

  padding: 0 !important;
  margin: -1px !important;

  overflow: hidden !important;

  white-space: nowrap !important;

  border: 0 !important;

  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
}
`, "",{"version":3,"sources":["webpack://./components/visually-hidden/index.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;;EAE7B,qBAAqB;EACrB,sBAAsB;;EAEtB,qBAAqB;EACrB,uBAAuB;;EAEvB,2BAA2B;;EAE3B,8BAA8B;;EAE9B,oBAAoB;;EAEpB,yCAAyC;EACzC,gCAAgC;AAClC","sourcesContent":[".visually-hidden {\n  position: absolute !important;\n\n  width: 1px !important;\n  height: 1px !important;\n\n  padding: 0 !important;\n  margin: -1px !important;\n\n  overflow: hidden !important;\n\n  white-space: nowrap !important;\n\n  border: 0 !important;\n\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  clip-path: inset(50%) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
